/**
 * The chat that opened the tab has nothing behind it, so its back buttons push a guard entry and send a Back
 * past it to Home rather than out of the site. The entry is marked so a pop that only lands on it, which is
 * how the media details modal drops its own entry on close, is not read as leaving the chat.
 */
export const chatBackGuardState = { chatBackGuard: true } as const;

export function isChatBackGuardEntry(state: unknown): boolean {
  return typeof state === "object" && state !== null && (state as { chatBackGuard?: unknown }).chatBackGuard === true;
}

/** The guard keeps the current entry's state, so the router's own index survives and every push after it stays a number. */
export function buildChatBackGuardState(currentState: unknown): Record<string, unknown> {
  const current = typeof currentState === "object" && currentState !== null ? (currentState as Record<string, unknown>) : {};
  return { ...current, ...chatBackGuardState };
}
